// removed by extract-text-webpack-plugin
module.exports = {"buttonEdit":"_3TzURcqWO0XUvq9A8BKZBc","removed":"_8DuyBKIKK3FRTyKDqpv3C"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/Action/style.scss
// module id = 962
// module chunks = 0